module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Library-092c0a76d98be180dd2cc799c7e241f166829b71abcf41ae5d90c5ad0d519daa.svg";